<template>
  <div>
    <div class="is-flex is-justify-content-flex-end">
      <b-tooltip v-if="hasPendingTaskGroup" position="is-left" type="is-light">
        <b-button v-if="hasPendingTaskGroup" icon-left="file-export" disabled>
          Import CSV
        </b-button>
        <template v-slot:content> Un groupe de transferts est déjà en cours. </template>
      </b-tooltip>
      <import-csv v-else label="Import CSV" :format="columns" :loading="loading" @submit="submit">
        <template v-if="errorImportMessages.length > 0" #append>
          <div class="control">
            <b-button
              type="is-danger"
              icon-left="exclamation-circle"
              @click="showErrorModal = true"
            >
              {{ errorImportMessages.length }}
            </b-button>
          </div>
        </template>
      </import-csv>
    </div>

    <b-modal :active="showErrorModal" has-modal-card @close="showErrorModal = false">
      <div class="modal-card">
        <div class="modal-card-head">
          <p class="modal-card-title">Erreurs d'importation</p>
        </div>
        <div class="modal-card-body">
          <b-message
            v-for="(error, index) in errorImportMessages"
            :key="index"
            type="is-danger"
            size="is-small"
            class="m-2"
          >
            {{ error }}
          </b-message>
        </div>
        <div class="modal-card-foot">
          <b-button @click="showErrorModal = false">Fermer</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { SPOT_TRACKER_SUBSCRIPTION_TASK_GROUP_STATUS } from './SpotTrackerSubscriptionTaskGroupTable.vue'
import {
  getErrorMessages,
  importSpotTrackerSubscriptionTaskError,
} from '@helpers/importErrorMessages'
import ImportCsv from '@components/ImportCsv.vue'
import { mapActions } from 'vuex'

export default {
  name: 'SpotTrackerSubscriptionTaskImport',

  components: {
    ImportCsv,
  },

  props: {
    spotTrackerSubscriptionTaskGroups: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      showErrorModal: false,
      errorImportMessages: [],
      columns: {
        from: 'From Number',
        to: 'To Number',
      },
    }
  },

  computed: {
    hasPendingTaskGroup() {
      return this.spotTrackerSubscriptionTaskGroups.some(
        (group) => group.status === SPOT_TRACKER_SUBSCRIPTION_TASK_GROUP_STATUS.PENDING,
      )
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit({ result }) {
      this.errorImportMessages = []
      this.showErrorModal = false

      const subscriptionTasks = result
        .filter((row) => row.from?.trim() || row.to?.trim())
        .map((row) => ({
          subscribedTrackerNumber: row.from?.trim().toUpperCase() || null,
          unsubscribedTrackerNumber: row.to?.trim().toUpperCase() || null,
        }))

      this.loading = true

      try {
        const response = await this.$services.spotTrackerSubscriptionTaskGroupService.import(
          subscriptionTasks,
        )

        this.$emit('update:spotTrackerSubscriptionTaskGroups', [
          response.spotTrackerSubscriptionTaskGroup,
          ...this.spotTrackerSubscriptionTaskGroups,
        ])

        this.addToastMessage({
          text: "L'import a été effectué.",
          type: 'is-success',
        })
      } catch (err) {
        this.errorImportMessages = getErrorMessages(err, importSpotTrackerSubscriptionTaskError)

        this.addToastMessage({
          text: "Impossible d'importer le fichier.",
          type: 'is-danger',
        })
      }

      this.loading = false
    },
  },
}
</script>
